import { z } from 'zod';

export const passwordSchema = z
  .string({ required_error: 'Hasło jest wymagane' })
  .min(1, 'Hasło jest wymagane')
  .min(8, 'Hasło musi mieć co najmniej 8 znaków')
  .max(64, 'Hasło jest zbyt długie')
  .regex(/^[A-Za-z0-9!@#$%^&*(),.?":{}|<>_\\/-]+$/, 'Hasło może zawierać tylko litery, cyfry i znaki specjalne')
  .regex(/[A-Z]/, 'Hasło musi zawierać co najmniej jedną wielką literę')
  .regex(/[a-z]/, 'Hasło musi zawierać co najmniej jedną małą literę')
  .regex(/[0-9]/, 'Hasło musi zawierać co najmniej jedną cyfrę')
  .regex(/[!@#$%^&*(),.?":{}|<>_\\/-]/, 'Hasło musi zawierać co najmniej jeden znak specjalny');
